// Georgia State's undergraduate majors (#2596, founder 2026-09-30: "majors
// offered by the college in the public page"). Read on 2026-09-30 from the
// official 2026-2027 Undergraduate Catalog (catalogs.gsu.edu, catoid 46): each
// college's "Departments and Programs" page, which links every program of
// study. Kept: every bachelor's program as the catalog names it ("Accounting,
// B.B.A." becomes Accounting, degree B.B.A.; a concentration the catalog lists
// as its own program keeps its concentration in the name). Two Robinson
// College programs are listed as "Hospitality Administration Major" and
// "Entrepreneurship Major" with no degree: no degree is shown. Perimeter
// College's associate degrees (A.A., A.S., A.S.N. pathways) are included
// because Georgia State admits first-year students to them. Left out: minors,
// certificates, B.S./M.S.-style dual and accelerated degrees, the LPN-BSN and
// RN-BSN completion programs, the core curriculum page, and Perimeter's
// non-degree education listings. The Honors College lists no programs of its
// own. Typography is plain ASCII. The KB's majors list was the starting point;
// the catalog wins. Majors are sorted by name within each college.
const majors = {
    "slug": "georgia-state-university",
    "read": "2026-09-30",
    "intro": "Every undergraduate major in Georgia State's official 2026-2027 Undergraduate Catalog, grouped by the college that offers it, with the degree it leads to, including Perimeter College's associate degrees. Minors, certificates and combined bachelor's-master's programs are left out.",
    "groups": [
        {
            "name": "Andrew Young School of Policy Studies",
            "source": {
                "label": "Georgia State 2026-2027 Undergraduate Catalog, Andrew Young School of Policy Studies Departments and Programs",
                "url": "https://catalogs.gsu.edu/content.php?catoid=46&navoid=5910"
            },
            "majors": [
                {
                    "name": "Criminal Justice",
                    "degree": "B.S."
                },
                {
                    "name": "Economics",
                    "degree": "B.A."
                },
                {
                    "name": "Economics",
                    "degree": "B.S."
                },
                {
                    "name": "International Economics and Modern Languages",
                    "degree": "B.A."
                },
                {
                    "name": "Public Policy",
                    "degree": "B.S."
                },
                {
                    "name": "Social Entrepreneurship",
                    "degree": "B.I.S."
                },
                {
                    "name": "Social Work",
                    "degree": "B.S.W."
                }
            ]
        },
        {
            "name": "College of Arts and Sciences",
            "source": {
                "label": "Georgia State 2026-2027 Undergraduate Catalog, College of Arts and Sciences Departments and Programs",
                "url": "https://catalogs.gsu.edu/content.php?catoid=46&navoid=5918"
            },
            "majors": [
                {
                    "name": "Africana Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Anthropology",
                    "degree": "B.A."
                },
                {
                    "name": "Applied Linguistics",
                    "degree": "B.A."
                },
                {
                    "name": "Asian Studies",
                    "degree": "B.I.S."
                },
                {
                    "name": "Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Biology and Data Science",
                    "degree": "B.I.S."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.S."
                },
                {
                    "name": "Data Science",
                    "degree": "B.S."
                },
                {
                    "name": "Data Science and Geographic Information Sciences",
                    "degree": "B.I.S."
                },
                {
                    "name": "English",
                    "degree": "B.A."
                },
                {
                    "name": "Environmental Science",
                    "degree": "B.I.S."
                },
                {
                    "name": "Game Design",
                    "degree": "B.A."
                },
                {
                    "name": "Game Development",
                    "degree": "B.S."
                },
                {
                    "name": "Geosciences",
                    "degree": "B.S."
                },
                {
                    "name": "Gerontology",
                    "degree": "B.I.S."
                },
                {
                    "name": "Global Studies",
                    "degree": "B.I.S."
                },
                {
                    "name": "History",
                    "degree": "B.A."
                },
                {
                    "name": "Information Technology",
                    "degree": "B.I.T."
                },
                {
                    "name": "Interdisciplinary Arts and Sciences",
                    "degree": "B.I.S."
                },
                {
                    "name": "Journalism",
                    "degree": "B.A."
                },
                {
                    "name": "Law and Society",
                    "degree": "B.I.S."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.S."
                },
                {
                    "name": "Media Entrepreneurship",
                    "degree": "B.I.S."
                },
                {
                    "name": "Neuroscience",
                    "degree": "B.S."
                },
                {
                    "name": "Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Philosophy, Politics, and Economics",
                    "degree": "B.I.S."
                },
                {
                    "name": "Physics",
                    "degree": "B.S."
                },
                {
                    "name": "Political Science",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology",
                    "degree": "B.S."
                },
                {
                    "name": "Religion, Health, and Leadership",
                    "degree": "B.I.S."
                },
                {
                    "name": "Sociology",
                    "degree": "B.A."
                },
                {
                    "name": "Speech Communication",
                    "degree": "B.A."
                },
                {
                    "name": "Speech, Language, and Hearing Sciences",
                    "degree": "B.I.S."
                },
                {
                    "name": "World Languages and Cultures",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "College of Education and Human Development",
            "source": {
                "label": "Georgia State 2026-2027 Undergraduate Catalog, College of Education and Human Development Departments and Programs",
                "url": "https://catalogs.gsu.edu/content.php?catoid=46&navoid=5919"
            },
            "majors": [
                {
                    "name": "Birth Through Five",
                    "degree": "B.S.E."
                },
                {
                    "name": "Deaf Studies, Deaf Education Concentration",
                    "degree": "B.A."
                },
                {
                    "name": "Deaf Studies, Sign Language Interpreting Concentration",
                    "degree": "B.A."
                },
                {
                    "name": "Elementary Education, Elementary Education and Special Education (P-5) Dual Certification Concentration",
                    "degree": "B.S.E."
                },
                {
                    "name": "Elementary Education, P-5 Certification Concentration",
                    "degree": "B.S.E."
                },
                {
                    "name": "Exercise Science",
                    "degree": "B.S."
                },
                {
                    "name": "Health and Physical Education & Coaching",
                    "degree": "B.S.E."
                },
                {
                    "name": "Human Learning and Development",
                    "degree": "B.I.S."
                },
                {
                    "name": "Middle Level Education",
                    "degree": "B.S.E."
                },
                {
                    "name": "Special Education",
                    "degree": "B.S.E."
                },
                {
                    "name": "Sport Administration",
                    "degree": "B.I.S."
                }
            ]
        },
        {
            "name": "Byrdine F. Lewis College of Nursing and Health Professions",
            "source": {
                "label": "Georgia State 2026-2027 Undergraduate Catalog, Byrdine F. Lewis College of Nursing and Health Professions Departments and Programs",
                "url": "https://catalogs.gsu.edu/content.php?catoid=46&navoid=5920"
            },
            "majors": [
                {
                    "name": "Dental Hygiene",
                    "degree": "B.S."
                },
                {
                    "name": "Health Informatics",
                    "degree": "B.I.S."
                },
                {
                    "name": "Health Sciences",
                    "degree": "B.I.S."
                },
                {
                    "name": "Nursing",
                    "degree": "B.S."
                },
                {
                    "name": "Nutrition",
                    "degree": "B.S."
                },
                {
                    "name": "Respiratory Therapy",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "J. Mack Robinson College of Business",
            "source": {
                "label": "Georgia State 2026-2027 Undergraduate Catalog, J. Mack Robinson College of Business Departments and Programs",
                "url": "https://catalogs.gsu.edu/content.php?catoid=46&navoid=5921"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "B.B.A."
                },
                {
                    "name": "Actuarial Science",
                    "degree": "B.B.A."
                },
                {
                    "name": "Computer Information Systems",
                    "degree": "B.B.A."
                },
                {
                    "name": "Entrepreneurship",
                    "degree": null
                },
                {
                    "name": "Finance",
                    "degree": "B.B.A."
                },
                {
                    "name": "Hospitality Administration",
                    "degree": null
                },
                {
                    "name": "Management",
                    "degree": "B.B.A."
                },
                {
                    "name": "Marketing",
                    "degree": "B.B.A."
                },
                {
                    "name": "Real Estate",
                    "degree": "B.B.A."
                },
                {
                    "name": "Risk Management and Insurance",
                    "degree": "B.B.A."
                }
            ]
        },
        {
            "name": "School of Public Health",
            "source": {
                "label": "Georgia State 2026-2027 Undergraduate Catalog, School of Public Health Departments and Programs",
                "url": "https://catalogs.gsu.edu/content.php?catoid=46&navoid=5922"
            },
            "majors": [
                {
                    "name": "Public Health",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "College of the Arts",
            "source": {
                "label": "Georgia State 2026-2027 Undergraduate Catalog, College of the Arts Schools and Programs",
                "url": "https://catalogs.gsu.edu/content.php?catoid=46&navoid=5924"
            },
            "majors": [
                {
                    "name": "Art",
                    "degree": "B.A."
                },
                {
                    "name": "Arts Administration Concentration",
                    "degree": "B.I.S."
                },
                {
                    "name": "Film and Media",
                    "degree": "B.A."
                },
                {
                    "name": "Interdisciplinary Studies - Acting Concentration",
                    "degree": "B.I.S."
                },
                {
                    "name": "Interdisciplinary Studies, Theatre Design (and Production) Concentration",
                    "degree": "B.I.S."
                },
                {
                    "name": "Music",
                    "degree": "B.M."
                },
                {
                    "name": "Music Industry",
                    "degree": "B.S."
                },
                {
                    "name": "Studio",
                    "degree": "B.F.A."
                }
            ]
        },
        {
            "name": "Institute for Biomedical Sciences",
            "source": {
                "label": "Georgia State 2026-2027 Undergraduate Catalog, Institute for Biomedical Sciences Programs",
                "url": "https://catalogs.gsu.edu/content.php?catoid=46&navoid=5929"
            },
            "majors": [
                {
                    "name": "Biomedical Science and Enterprise",
                    "degree": "B.I.S."
                }
            ]
        },
        {
            "name": "Perimeter College",
            "source": {
                "label": "Georgia State 2026-2027 Undergraduate Catalog, Perimeter College Departments and Programs",
                "url": "https://catalogs.gsu.edu/content.php?catoid=46&navoid=5923"
            },
            "majors": [
                {
                    "name": "Actuarial Science Pathway",
                    "degree": "A.S."
                },
                {
                    "name": "African American Studies Pathway",
                    "degree": "A.A."
                },
                {
                    "name": "American Sign Language Pathway",
                    "degree": "A.A."
                },
                {
                    "name": "Anthropology Pathway",
                    "degree": "A.A."
                },
                {
                    "name": "Art Pathway",
                    "degree": "A.A."
                },
                {
                    "name": "Art Pathway",
                    "degree": "A.S."
                },
                {
                    "name": "Biology Pathway",
                    "degree": "A.S."
                },
                {
                    "name": "Business Administration Pathway",
                    "degree": "A.S."
                },
                {
                    "name": "Chemistry Pathway",
                    "degree": "A.S."
                },
                {
                    "name": "Computer Science Pathway",
                    "degree": "A.S."
                },
                {
                    "name": "Criminal Justice Pathway",
                    "degree": "A.S."
                },
                {
                    "name": "Dental Hygiene",
                    "degree": "A.S."
                },
                {
                    "name": "Education Pathway",
                    "degree": "A.S."
                },
                {
                    "name": "Engineering Pathway",
                    "degree": "A.S."
                },
                {
                    "name": "English Pathway",
                    "degree": "A.A."
                },
                {
                    "name": "Environmental Science Pathway",
                    "degree": "A.S."
                },
                {
                    "name": "Film and Media Studies Pathway",
                    "degree": "A.A."
                },
                {
                    "name": "General Studies Pathway",
                    "degree": "A.S."
                },
                {
                    "name": "Geology Pathway",
                    "degree": "A.S."
                },
                {
                    "name": "Health Sciences Pathway",
                    "degree": "A.S."
                },
                {
                    "name": "History Pathway",
                    "degree": "A.A."
                },
                {
                    "name": "Homeland Security and Emergency Management Pathway",
                    "degree": "A.A."
                },
                {
                    "name": "Journalism Pathway",
                    "degree": "A.A."
                },
                {
                    "name": "Kinesiology and Health Pathway",
                    "degree": "A.S."
                },
                {
                    "name": "Mathematics Pathway",
                    "degree": "A.S."
                },
                {
                    "name": "Music Pathway",
                    "degree": "A.S."
                },
                {
                    "name": "Nursing",
                    "degree": "A.S.N."
                },
                {
                    "name": "Philosophy Pathway",
                    "degree": "A.A."
                },
                {
                    "name": "Physics Pathway",
                    "degree": "A.S."
                },
                {
                    "name": "Political Science Pathway",
                    "degree": "A.A."
                },
                {
                    "name": "Psychology Pathway",
                    "degree": "A.S."
                },
                {
                    "name": "Public Health Pathway",
                    "degree": "A.S."
                },
                {
                    "name": "Social Work Pathway",
                    "degree": "A.S."
                },
                {
                    "name": "Sociology Pathway",
                    "degree": "A.A."
                },
                {
                    "name": "Speech Communication Pathway",
                    "degree": "A.A."
                },
                {
                    "name": "Sport Management Pathway",
                    "degree": "A.S."
                },
                {
                    "name": "Theatre Pathway",
                    "degree": "A.A."
                },
                {
                    "name": "World Languages - Business and Economics Pathway",
                    "degree": "A.A."
                },
                {
                    "name": "World Languages Pathway",
                    "degree": "A.A."
                }
            ]
        }
    ]
};

export default majors;
